import React, { useCallback } from 'react';
import useStyles from 'hooks/useStyles';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import PromotionModal from 'routes/live/components/dialogs/PromotionModal';
import Link from 'components/Link';

import { getLivePromotionModal } from 'reduxModules/live/selector';

import { closeLiveModal } from 'reduxModules/live/action';
import { SIGNUP_HINT } from 'routes/live/constants/modalName';
import { SIGNUP, LOGIN, LIVE } from 'constants/routingPath';
import history from 'history.js';

import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';

import styles from './ModalSwitcher.scss';

function ModalSwitcher() {
  useStyles(styles);
  const { t } = useTranslation(['live']);
  const { modalName } = useSelector(getLivePromotionModal);

  const getOfficialSiteURL = useGetOfficialSiteURL();
  const snapaskSignUpUrl = getOfficialSiteURL(SIGNUP);
  const LIVE_URL = getOfficialSiteURL(LIVE);
  const snapaskSignInUrl = getOfficialSiteURL(LOGIN, {
    returnto: LIVE_URL,
  });

  const dispatch = useDispatch();

  const onModalClose = useCallback(() => {
    dispatch(closeLiveModal());
  }, [dispatch]);

  const onSignupClick = () => {
    history.push(snapaskSignUpUrl);
  };

  const loginHint = (
    <div className={styles.loginHint}>
      <span className={styles.text}>{t('promote.notSignedIn.login_desc')}</span>
      <Link to={snapaskSignInUrl}>{t('promote.notSignedIn.login_cta')}</Link>
    </div>
  );

  const Modals = {
    [SIGNUP_HINT]: (
      <PromotionModal
        onClose={onModalClose}
        notice={t('promote.notSignedIn.notice')}
        title={t('home.unsubscribe.title')}
        description={t('promote.notSignedIn.desc')}
        ctaText={t('promote.notSignedIn.cta')}
        onCtaClick={onSignupClick}
        hint={loginHint}
      />
    ),
  };

  if (!modalName || !Modals[modalName]) return null;

  return Modals[modalName];
}
export default ModalSwitcher;
